import React, { Fragment } from 'react'

import GreyDot from './greyDot'
import GreenDot from '../generic/checkDot'
import BlueDot from './blueDot'
import DividingLine from './progressLine'

import { greenBase, grayLight40 } from '../../constants/principles'

export default ({ index, currentStep, furthestStep, first, last, length }) => {
  if (index === currentStep) {
    return (
      <Fragment>
        {!first && <DividingLine length={length} color={greenBase} />}
        <BlueDot />
        {!last && <DividingLine length={length} color={furthestStep > currentStep ? greenBase : grayLight40} />}
      </Fragment>
    )
  }
  if (index < currentStep || index < furthestStep) {
    return (
      <Fragment>
        {!first && <DividingLine length={length} color={greenBase} />}
        <GreenDot color={greenBase} />
        {!last && <DividingLine length={length} color={greenBase} />}
      </Fragment>
    )
  }
  if (index > currentStep && index === furthestStep) {
    return (
      <Fragment>
        {!first && <DividingLine length={length} color={greenBase} />}
        <GreenDot color={greenBase} noCheck={true} />
        {!last && <DividingLine length={length} color={grayLight40} />}
      </Fragment>
    )
  }

  if (index > currentStep) {
    return (
      <Fragment>
        {!first && <DividingLine length={length} color={grayLight40} />}
        <GreyDot />
        {!last && <DividingLine length={length} color={grayLight40} />}
      </Fragment>
    )
  }
}
